var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-merchant-card",on:{"click":function($event){return _vm.goToDetailMerchant(_vm.slug)}}},[_c('ImageLazy',{staticClass:"toko-img",attrs:{"src":_vm.img,"alt":_vm.name + 'png'}}),_vm._v(" "),_c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.city))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }